import { CustomButton } from "../../../../core/components/CustomButton";
import { ModalSimple } from "../../../../core/components/Modal";
import { Row } from "../../../../core/components/Row";
import { WarningBG } from "../../../../core/icons/Warning";
import { Likes } from "../../../match/domain/entities/userMatch";
import { useHandleDeleteNotification } from "../../../notification/presentation/hook/useHandleDeleteNotification";

export const ModalRestricted = ({
	userInfoProfile,
	action,
	setAction,
	category,
}: {
	userInfoProfile: Partial<Likes | undefined>;
	action: boolean;
	setAction: React.Dispatch<React.SetStateAction<boolean>>;
	category: "like" | "match" | "alert" | "myLikes";
}) => {
	const handleDeleteAction = useHandleDeleteNotification();

	const handleDelete = async () => {
		handleDeleteAction(category, userInfoProfile as Likes);
		setAction(false);
	};

	const modalContent = {
		like: {
			title: "User not found",
			message: `The user ${(userInfoProfile as Likes)?.username} no longer exists.`,
			buttonLabel: "Remove Like",
		},
		match: {
			title: "User not found",
			message: `The user ${(userInfoProfile as Likes)?.username} no longer exists.`,
			buttonLabel: "Remove Match",
		},
		myLikes: {
			title: "User not found",
			message: `The user ${(userInfoProfile as Likes)?.username} no longer exists.`,
			buttonLabel: "Remove My Like",
		},
		alert: {
			title: "Alert not found",
			message: `This alert no longer exists.`,
			buttonLabel: "Remove Alert",
		},
	};

	return (
		<>
			{action && (
				<ModalSimple
					title={modalContent[category]?.title || "User not found"}
					variant="secondary"
					actionExecuted={action}
					onClose={() => setAction(false)}
					icon={<WarningBG />}
					next
					endButtons={
						<Row className="sticky bg-white border border-transparent bottom-0 gap-4">
							<CustomButton
								onClick={handleDelete}
								className="w-1/2 text-primary"
								color="white"
								small
							>
								{modalContent[category]?.buttonLabel || "Remove"}
							</CustomButton>
							<CustomButton
								onClick={() => setAction(false)}
								className="w-1/2"
								small
							>
								Close
							</CustomButton>
						</Row>
					}
				>
					{modalContent[category]?.message || `The user ${userInfoProfile?.username} no longer exists.`}
				</ModalSimple>
			)}
		</>
	);
};
